import {IManagableObject} from "../../IManagableObject";

export class DriversViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Phone: string = "";
  Category: string = "";
  Class: string = "";
  DriverLicence: string = "";
  DriverLicenseTill: number = undefined;
  InternalId: string = "";
  InsuranceID: string = "";
  InsuranceTill: number = undefined;

  // TODO: remove groups, keep only GroupIds
  Groups: number[] = [];
  GroupIds: number[] = [];
  Keys: number[] = [];

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Phone = data["phone"];
      this.Category = data["category"];
      this.Class = data["class"];
      this.DriverLicence = data["driverLicence"];
      this.InternalId = data["internalId"];
      this.InsuranceID = data["insuranceId"];
      this.InsuranceTill = data["insuranceTill"];
      this.DriverLicenseTill = data["driverLicenseTill"];
      this.Keys = data["keys"];
      this.Groups = data["groupIds"];
      this.GroupIds = this.Groups;
    }
  }

  static fromJS(data: any): DriversViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new DriversViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
